import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchAllServiceFailure,
  fetchAllServiceSuccess,
  serviceAddFailure,
  serviceAddSuccess,
  serviceDeleteFailure,
  serviceDeleteSuccess,
  serviceUpdateFailure,
  serviceUpdateSuccess,
  serviceViewAllFailure,
  serviceViewAllSuccess,
  serviceViewFailure,
  serviceViewRequest,
  serviceViewSuccess,
  updateServiceApprovalFailure,
  updateServiceApprovalSuccess,
} from "./ServiceAction";
import {
  fetchAllServiceEffect,
  serviceAddEffect,
  serviceApprovalEffect,
  serviceDeleteEffect,
  serviceUpdateEffect,
  serviceViewAllEffect,
  serviceViewEffect,
} from "./ServiceEffect";
import {
  FETCH_ALL_SERVICES_REQUEST,
  SERVICE_ADD_REQUEST,
  SERVICE_DELETE_REQUEST,
  SERVICE_UPDATE_REQUEST,
  SERVICE_VIEW_ALL_REQUEST,
  SERVICE_VIEW_REQUEST,
  UPDATE_SERVICE_APPROVAL_REQUEST,
} from "./ServiceType";

function* serviceViewSaga({ payload }) {
  try {
    const response = yield call(serviceViewEffect, payload);
    yield put(serviceViewSuccess(response));
  } catch (err) {
    yield put(serviceViewFailure(err || "Faile to fetch service"));
  }
}
function* fetchAllServiceSaga() {
  try {
    const response = yield call(fetchAllServiceEffect);
    yield put(fetchAllServiceSuccess(response));
  } catch (error) {
    yield put(fetchAllServiceFailure(error || "Failed to fetch services"));
  }
}

function* serviceViewAllSaga({ payload }) {
  try {
    const response = yield call(serviceViewAllEffect, payload);
    console.log("response", response);
    yield put(serviceViewAllSuccess(response));
  } catch (error) {
    yield put(serviceViewAllFailure(error || "Failed to fetch services"));
  }
}

function* serviceAddSaga({ payload }) {
  try {
    const response = yield call(serviceAddEffect, payload);
    console.log("addsaga", response);
    yield put(serviceAddSuccess(response));
  } catch (err) {
    console.log("err", err);
    yield put(serviceAddFailure(err.response.data || "Failed To Add Service"));
  }
}

function* serviceUpdataSaga({ payload }) {
  try {
    const response = yield call(serviceUpdateEffect, payload);

    yield put(serviceUpdateSuccess(response));
  } catch (err) {
    console.log("error", err);
    yield put(serviceUpdateFailure(err || "Failed To Update Service"));
  }
}

function* serviceDeleteSaga({ payload }) {
  try {
    const response = yield call(serviceDeleteEffect, payload);

    yield put(serviceDeleteSuccess(response));
  } catch (err) {
    yield put(serviceDeleteFailure(err || "Failed To Delete Service"));
  }
}

function* updateServiceApprovalSaga({ payload }) {
  try {
    const response = yield call(serviceApprovalEffect, payload);

    yield put(updateServiceApprovalSuccess(response.message));

    yield put(serviceViewRequest(payload.serviceId));
  } catch (error) {
    yield put(updateServiceApprovalFailure(error));
  }
}

export default function* serviceSaga() {
  yield takeLatest(SERVICE_VIEW_ALL_REQUEST, serviceViewAllSaga);
  yield takeLatest(SERVICE_ADD_REQUEST, serviceAddSaga);
  yield takeLatest(SERVICE_UPDATE_REQUEST, serviceUpdataSaga);
  yield takeLatest(SERVICE_VIEW_REQUEST, serviceViewSaga);
  yield takeLatest(SERVICE_DELETE_REQUEST, serviceDeleteSaga);
  yield takeLatest(FETCH_ALL_SERVICES_REQUEST, fetchAllServiceSaga);
  yield takeLatest(UPDATE_SERVICE_APPROVAL_REQUEST, updateServiceApprovalSaga);
}
